export const graphqlPath = "https://api.berwickinstech.com";
export const feedbackEmailAddress = [
  "dparker@berwickinsurance.com",
  "daniel@berwickinsurance.com",
  "traci.bohme@berwickinsurance.com",
  "bit.testing@berwickinsurance.com",
];
export const subscriptionsPath = "wss://api.berwickinstech.com";
